
import Vue from 'vue'
import { RButton } from '@/components'
import { addPostfixIfNumber } from '@/services/strings'

export default Vue.extend({
  name: 'CustomModal',
  components: {
    RButton,
  },
  props: {
    clickAwayClose: {
      type: Boolean,
      default: true,
    },
    maxWidth: {
      type: [String, Number],
      default: '600px',
    },
    minWidth: {
      type: [String, Number],
    },
    width: {
      type: String,
      default: 'auto',
    },
    closingX: {
      type: Boolean,
      default: false,
    },
    modalStyles: {
      type: Object,
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown)
    document.body.style.overflow = 'hidden'
    document.body.style.height = '100vh'
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown)
    document.body.style.overflow = 'auto'
    document.body.style.height = 'auto'
  },
  methods: {
    handleMaskClick(): void {
      if (!this.clickAwayClose) return
      this.$emit('close')
    },
    handleKeyDown(e: KeyboardEvent): void {
      if (e.code === 'Escape') {
        this.$emit('close')
      }
    },
  },
  computed: {
    styles(): any {
      const { maxWidth, minWidth, width, modalStyles } = this
      if (modalStyles) return modalStyles
      return {
        maxWidth: addPostfixIfNumber(maxWidth),
        minWidth: addPostfixIfNumber(minWidth),
        width,
      }
    },
  },
})
